<template lang="pug">
cadastrante-sicarf(:cadastrante="cadastro.cadastrante")
</template>

<script>
import CadastranteSicarf from '../../../../components/cadastro/CadastranteSicarf'

export default {
  props: ['cadastro'],

  components: {
    CadastranteSicarf
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/permuta/components/Cadastrante.vue